// REACT IMPORTS
import React from "react";

// ICONS IMPORTS
import { InfoCircleIcon } from "icons/warning/InfoCircleIcon";
import { CloseIcon } from "icons/close/CloseIcon";
import { useTid } from "utils/testid";

// PROPS TYPE
interface WarningBarProps {
  content: string;
  onCloseClick?: any;
}
/* ------------------------------------- WARNING BAR ------------------------------------- */

const WarningBar = (props: WarningBarProps) => {
  const tid = useTid();
  const { content, onCloseClick } = props;

  return (
    <div
      className="flex bg-lightYellow h-full py-[6px] lg:px-6 px-5  lg:items-center justify-between"
      role="region"
      aria-label="Warning"
      data-testid={tid("warning-bar")}
    >
      <div className="flex lg:items-center gap-2 max-w-[90%]">
        {/* shrink-0 stops the flex row squashing the icon down to a few pixels
            once the notice wraps onto several lines. */}
        <InfoCircleIcon aria-hidden="true" className="shrink-0" />
        <p
          id="warning-content"
          data-testid={tid("warning-content")}
          className="text-yellow lg:text-base md2:text-sm text-xs leading-normal font-medium "
          dangerouslySetInnerHTML={{ __html: content }}
        ></p>
      </div>
      <div
        onClick={onCloseClick}
        role="button"
        tabIndex={0}
        aria-label="Dismiss warning"
        data-testid={tid("dismiss-warning-button")}
        className="shrink-0 self-start lg:self-center"
      >
        {/* 20px matches the close on the notifications panel; the old 30px
            dwarfed the notice text it sits beside. */}
        <CloseIcon size={20} className="cursor-pointer" aria-hidden="true" />
      </div>
    </div>
  );
};

export default WarningBar;
